@if (data(); as data) {
  @if (isPending()) {
    <div class="proposed-action">
      <div class="proposed-action__header">
        <mat-icon class="proposed-action__header-icon">bolt</mat-icon>
        <span class="proposed-action__title">{{ 'AI_ASSISTANT.PROPOSED_ACTION.TITLE' | translate }}</span>
      </div>

      @if (data.reasoningSummary) {
        <p class="proposed-action__summary">{{ data.reasoningSummary }}</p>
      }
      <p class="proposed-action__function-id">
        {{ 'AI_ASSISTANT.PROPOSED_ACTION.TOOL' | translate: { functionId: data.functionId } }}
      </p>

      <mat-accordion>
        <mat-expansion-panel class="proposed-action__details-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>{{ 'AI_ASSISTANT.PROPOSED_ACTION.VIEW_DETAILS' | translate }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="proposed-action__arguments">
            <span class="proposed-action__arguments-label">
              {{ 'AI_ASSISTANT.PROPOSED_ACTION.ARGUMENTS' | translate }}
            </span>
            <pre class="proposed-action__arguments-code">{{ formattedArguments() }}</pre>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      @if (isRejecting()) {
        <mat-form-field appearance="outline" class="proposed-action__feedback-field">
          <textarea
            matInput
            rows="4"
            [placeholder]="'AI_ASSISTANT.PROPOSED_ACTION.FEEDBACK_PLACEHOLDER' | translate"
            [value]="feedbackText()"
            (input)="onFeedbackInput($event)"
          ></textarea>
        </mat-form-field>

        <div class="proposed-action__actions">
          <button mat-stroked-button type="button" (click)="onCancelReject()">
            {{ 'AI_ASSISTANT.PROPOSED_ACTION.CANCEL' | translate }}
          </button>
          <button mat-flat-button color="warn" type="button" [disabled]="actionInProgress()" (click)="onSubmitRejection()">
            {{ 'AI_ASSISTANT.PROPOSED_ACTION.SUBMIT_REJECTION' | translate }}
          </button>
        </div>
      } @else {
        <div class="proposed-action__actions">
          <button mat-flat-button color="primary" type="button" [disabled]="actionInProgress()" (click)="onApprove()">
            {{ 'AI_ASSISTANT.PROPOSED_ACTION.APPROVE' | translate }}
          </button>
          <button mat-stroked-button type="button" [disabled]="actionInProgress()" (click)="onStartReject()">
            {{ 'AI_ASSISTANT.PROPOSED_ACTION.REJECT_WITH_FEEDBACK' | translate }}
          </button>
        </div>
      }
    </div>
  }

  @if (isApproved()) {
    <div class="proposed-action-resolved">
      <div class="proposed-action-resolved__top-line">
        <span class="proposed-action-resolved__status proposed-action-resolved__status--approved">
          <mat-icon class="proposed-action-resolved__icon">check_circle</mat-icon>
          <strong>{{ 'AI_ASSISTANT.PROPOSED_ACTION.APPROVED' | translate }}</strong>
        </span>
        <span class="proposed-action-resolved__separator">&middot;</span>
        <span class="proposed-action-resolved__summary">{{ data.functionId }}</span>
        @if (data.reasoningSummary) {
          <span class="proposed-action-resolved__separator">&middot;</span>
          <span class="proposed-action-resolved__summary">{{ data.reasoningSummary }}</span>
        }
      </div>
    </div>
  }

  @if (isSuperseded()) {
    <div class="proposed-action-resolved">
      <div class="proposed-action-resolved__top-line">
        <span class="proposed-action-resolved__status proposed-action-resolved__status--superseded">
          <mat-icon class="proposed-action-resolved__icon">skip_next</mat-icon>
          <strong>{{ 'AI_ASSISTANT.PROPOSED_ACTION.SUPERSEDED' | translate }}</strong>
        </span>
        <span class="proposed-action-resolved__separator">&middot;</span>
        <span class="proposed-action-resolved__summary">{{ data.functionId }}</span>
      </div>
    </div>
  }

  @if (isRejected()) {
    <div class="proposed-action-resolved">
      <div class="proposed-action-resolved__top-line">
        <span class="proposed-action-resolved__status proposed-action-resolved__status--rejected">
          <mat-icon class="proposed-action-resolved__icon">cancel</mat-icon>
          <strong>{{ 'AI_ASSISTANT.PROPOSED_ACTION.REJECTED' | translate }}</strong>
        </span>
        <span class="proposed-action-resolved__separator">&middot;</span>
        <span class="proposed-action-resolved__summary">{{ data.functionId }}</span>
        @if (data.reasoningSummary) {
          <span class="proposed-action-resolved__separator">&middot;</span>
          <span class="proposed-action-resolved__summary">{{ data.reasoningSummary }}</span>
        }
      </div>
      @if (data.feedback) {
        <span class="proposed-action-resolved__feedback">"{{ data.feedback }}"</span>
      }
    </div>
  }
}
